import { Routes } from '@angular/router';
import { ProfileV2Component } from './profile-v2.component';
import { RecentActivityComponent } from './recent-activity/recent-activity.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { UserInfoEditComponent } from './user-info-edit/user-info-edit.component';
import { PaymentAccountComponent } from './payment-account/payment-account.component';
import { SummaryComponent } from './payment-account/summary/summary.component';
import { DetailsComponent } from './payment-account/details/details.component';
import { AddComponent } from './payment-account/add/add.component';

export const routes: Routes = [
  {
    path: '',
    component: ProfileV2Component,
    children: [
      { path: '', component: UserInfoComponent },
      { path: 'edit', component: UserInfoEditComponent },
      {
        path: 'recent-activity',
        component: RecentActivityComponent,
        data: { breadcrumb: 'profile.recentActivity' }
      },
      {
        path: 'payment-account',
        component: PaymentAccountComponent,
        children: [
          { path: 'summary', component: SummaryComponent },
          { path: 'details/:id', component: DetailsComponent },
          { path: 'add', component: AddComponent }
        ]
      }
    ]
  }
];
